/** TYPES **/
export const filesTypes = {
  UPLOAD_FILE: 'UPLOAD_FILE',
  UPLOAD_FILES: 'UPLOAD_FILES',
  DOWNLOAD_FILE: 'DOWNLOAD_FILE',
  GET_PDF: 'GET_PDF',
  SET_PDF: 'SET_PDF'
}

/** ACTIONS **/
export interface UploadFileAction {
  type: typeof filesTypes.UPLOAD_FILE
  payload: File
  callback: (succ: boolean, fileName?: string, uploadUrl?: string) => void
}

export interface UploadFilesAction {
  type: typeof filesTypes.UPLOAD_FILES
  payload: File[]
  callback: (succ: boolean, fileNameList?: string[]) => void
}

export interface DownloadFileAction {
  type: typeof filesTypes.DOWNLOAD_FILE
  payload: DownloadFilePayload
  callback: (succ: boolean, pdfUrl?: string) => void
}

export interface GetPDFAction {
  type: typeof filesTypes.GET_PDF
  payload: string
  callback: (succ: boolean, pdfUrl?: string) => void
}

export interface SetPDFAction {
  type: typeof filesTypes.SET_PDF
  payload: string
}

export interface DownloadFilePayload {
  documentType: "WORK_ORDER" | "ESTIMATE" | "JOB" | "INVOICE"
  resourceId: string
  parameters: {
    hidePricing?: boolean
    hideBefore?: boolean
    hideAfter?: boolean
    hideRepairNotes?: boolean
    hideInspectionNotes?: boolean
    hidePhotoNotes?: boolean
    groupBy?: "CATEGORY" | "STATUS" | "PRIORITY"
    hideItems?: boolean
    onlyApproved?: boolean
    hideImages?: boolean
    showPreliminaryItems?: boolean
  }
}

export type FilesActions =
  | UploadFileAction
  | UploadFilesAction
  | DownloadFileAction
  | GetPDFAction
  | SetPDFAction